module.exports = __webpack_public_path__ + "img/logo-reader.863ee97c.png";